import React, { useEffect, useState } from "react";
import "./payments.css";
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css'
import { useTicketStore } from "../../store";
import { useNavigate, useParams } from "react-router";

function Payments() {
  const {ticket} =useTicketStore()
  let navigate = useNavigate();
const {id} = useParams()
    const [details, setDetails] = useState({
        cvc: '',
        expiry:'',
        focus:'',
        name:'',
        number:'',
      })
    
     const handleInputFocus = (e) =>{
        details["focus"] = e.target.name
      }
    
    useEffect(() => {
     if(ticket===0){
       navigate("/")
     }
    }, [ticket])

  return (
    <div className="payment-container"> 
    <div className="paymentForm"> 
    <Cards
      cvc={details["cvc"]}
      expiry={details["expiry"]}
      focused={details["focus"]}
      name={details["name"]}
      number={details["number"]}
      acceptedCards={['visa', 'mastercard']}
      placeholders={{name:"Your name", }}
      locale={{valid: "Expiry"}}
      
    />

    <form className="form" onSubmit={(e) =>{
      e.preventDefault()
     let result =  window.confirm( `You've Booked ${ticket} ticket for ${id}.` )
     if(result){

       navigate("/")
     }
      }}>

      <div className="divInputs">
      <input className="inputs"
          placeholder="Card Number"
          name="number"
          type="number"
          onChange={(e)=>setDetails({...details, number : e.target.value})}
          onFocus={handleInputFocus}
          required={true}
        />

      
        <input className="inputs"
          placeholder="Name on Card"
          name="name"
          onChange={(e)=>setDetails({...details, name : e.target.value})}

          onFocus={handleInputFocus}
          required={true}
        />
      </div>
      

      <div className="inputsRow">
      <input className="inputs inputdivide"
          placeholder="MM/YY"
          name="expiry"
          onChange={(e)=>setDetails({...details, expiry : e.target.value})}
          maxlength="4"

          onFocus={handleInputFocus}
          maxLength={6}
          required={true}
        />
       

        <input  className="inputs inputdivide"
          placeholder="CVV"
          name="cvc"
          type="number"
          maxlength="3"
          onChange={(e)=>{setDetails({...details, cvc : e.target.value})}}
          onFocus={handleInputFocus}
          maxLength={4}
          required={true}
        />  
      </div>  
      <button className="pay">{`To Pay $${ticket*5}`}</button>
    </form>

  
  </div>
  </div>
  );
}

export default Payments;
